export default "__VITE_ASSET__D7L5Rvwr__"